import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { PositionService } from 'src/app/services/position.service';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';
import { RELOAD_POSITIONS_KEY } from 'src/app/util/storage-util';

@Component({
    selector: 'job-unavailable-modal',
    templateUrl: './job-unavailable-modal.component.html',
    styleUrls: ['./job-unavailable-modal.component.scss'],
})

export class JobUnavailableModalComponent {
    @Input() hasOtherSchedules: boolean = false;
    @Input() isJobDirectInvite?: boolean = false;
    @Input() jobExternalId?: string;
    @Output() confirmEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private modalCtrl: ModalController,
                private readonly positionService: PositionService,
                private readonly segmentCMOS: SegmentCMOSService,
                private readonly storage: Storage) { }

    async onDismiss() {
        this.modalCtrl.dismiss();
        this.confirmEvent.emit();
    }

    getJobUnavailableText() {
        return this.hasOtherSchedules ? 'But, there are other schedules available for this position' : 'There are other jobs available, keep browsing!';
    }
}
